import axios from "axios";
import baseUrl from "./baseUrl";

const api = axios.create({
  baseURL: baseUrl,
  headers: {
    empresa: localStorage.empresa,
    usuario: localStorage.usuario
  }
});

export default api;